import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import OTP from './pages/OTP';
import Signup from './pages/Signup';
import Viewer from './pages/Viewer';
import SignupMessage from './pages/SignupMessage';

import '@fontsource/barlow';

const theme = createTheme({
  typography: {
    fontFamily: 'Barlow, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Global style reset */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/viewer" element={<Viewer />} />
          <Route path="/signupmessage" element={<SignupMessage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

